module.exports = __webpack_public_path__ + "assets/img/One Holland Village.a7ed60d0.jpg";